import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pencil.icon",
  "use": "pencil.icon-usage",
  "viewBox": "134.186 -11768.45 24.434 24.45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"134.186 -11768.45 24.434 24.45\" id=\"pencil.icon\"><defs><style>#pencil.icon .cls-1{fill:#486171}</style></defs><g id=\"pencil.icon_Group_656\" data-name=\"Group 656\" transform=\"translate(105 -53)\"><path id=\"pencil.icon_Subtraction_29\" data-name=\"Subtraction 29\" class=\"cls-1\" d=\"M0,4.746H0V0L5.213,2.373,0,4.746Z\" transform=\"rotate(135 2440.163 -5839.84)\" /><path id=\"pencil.icon_Rectangle_125\" data-name=\"Rectangle 125\" class=\"cls-1\" transform=\"rotate(45 14159.887 -5800.029)\" d=\"M0 0H4.831V17.907H0z\" /><path id=\"pencil.icon_Rectangle_127\" data-name=\"Rectangle 127\" class=\"cls-1\" transform=\"rotate(45 14162.352 -5799.008)\" d=\"M0 0H4.831V1.257H0z\" /><path id=\"pencil.icon_Rectangle_126\" data-name=\"Rectangle 126\" class=\"cls-1\" d=\"M1,0H3.831a1,1,0,0,1,1,1V2.984a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z\" transform=\"rotate(45 14166.901 -5797.123)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pencil.icon.svg
// module id = vmmc
// module chunks = 13